<!--
 * @Author: Latte
 * @Date: 2021-08-17 09:41:20
 * @LAstEditors: Latte
 * @LastEditTime: 2021-11-19 17:52:13
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\diagnosisManagement\teamMgt\request\reqDetail\index.vue
-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <el-form :model="reqList" label-width="140px" label-position="left">
        <el-row>
          <el-col :span="8">
            <el-form-item label="审核状态：">
              <div>{{ formatAuditStatus }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="审核时间：">
              <div>{{ reqList.auditTime | formatDateTime }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请时间：">
              <div>{{ reqList.createTime | formatDateTime }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="申请用户 ID：">
              <div>{{ reqList.auditStatus }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请用户名称：">
              <div>{{ reqList.nickname }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请人身份证号码：">
              <div>{{ reqList.idnumber }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="身份证反面照片：">
              <el-image
                style="width: 280px; height: 180px"
                :src="formatIDreversePic"
                fit="contain"
              ></el-image>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="身份证正面照片：">
              <el-image
                style="width: 280px; height: 180px"
                :src="formatIDfrontPic"
                fit="contain"
              ></el-image>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="医师资格证：">
              <el-image
                style="width: 280px; height: 180px"
                :src="formatPhysicianLicence"
                fit="contain"
              ></el-image>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="手机号码：">
              <div>{{ reqList.mobilePhone }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请角色：">
              <div>{{ formatRole }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="工作地点：">
              <div>{{ formatWorkPlace }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="申请单位：">
              <div>{{ reqList.company }}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="拒绝原因：">
          <el-input
            v-model="reqList.reason"
            type="textarea"
            rows="5"
            disabled
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="goBack()"
            >返回</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getReqDetail } from "@/api/system/diagnosisManagement/joinTeamRequest";
import dayjs from "dayjs";
export default {
  data() {
    return {
      reqList: {}, // 入团申请详情列表
    };
  },

  computed: {
    formatAuditStatus() {
      let auditStatus = this.reqList.auditStatus;
      let formatAuditStatus = "";
      switch (auditStatus) {
        case 0:
          formatAuditStatus = "未审核";
          break;
        case 1:
          formatAuditStatus = "通过";
          break;
        case 2:
          formatAuditStatus = "未通过";
      }
      return formatAuditStatus;
    },

    formatIDreversePic() {
      let IDreversePic = this.reqList.idreversePic;
      let formatIDreversePic = process.env.VUE_APP_RESOURCES + IDreversePic;
      return formatIDreversePic;
    },

    formatIDfrontPic() {
      let IDfrontPic = this.reqList.idfrontPic;
      let formatIDfrontPic = process.env.VUE_APP_RESOURCES + IDfrontPic;
      return formatIDfrontPic;
    },

    formatPhysicianLicence() {
      let physicianLicence = this.reqList.physicianLicence;
      let formatPhysicianLicence =
        process.env.VUE_APP_RESOURCES + physicianLicence;
      return formatPhysicianLicence;
    },

    formatRole() {
      let role = this.reqList.role;
      let formatRole = "";
      switch (role) {
        case 0:
          formatRole = "医生";
          break;
        case 1:
          formatRole = "会诊专家";
          break;
        case 2:
          formatRole = "医生&会诊专家";
      }
      return formatRole;
    },

    formatWorkPlace() {
      let formatWorkPlace =
        this.reqList.workProvince +
        this.reqList.workDistrict +
        this.reqList.workCity;
      return formatWorkPlace;
    },
  },

  methods: {
    goBack() {
      this.goBackFlag = 1;
      this.$router.go(-1);
    },

    /**
     * @description: 获取入团申请详情
     * @param {*}
     * @return {*}
     */
    getReqDetail() {
      const teamUserReqID = this.$route.params.teamUserReqID;

      const params = {
        teamUserReqID: teamUserReqID,
      };

      getReqDetail(params).then((res) => {
        this.reqList = res.data;
        console.log(" ----------------------------------------");
        console.log("getReqDetail , this.reqList", this.reqList);
        console.log(" ----------------------------------------");
      });
    },
  },

  created() {
    this.getReqDetail();
  },
};
</script>

<style>
</style>